<template>
    <div class="page-goods page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="12">
                    <h3 style="float: none;">产品列表</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>产品管理</el-breadcrumb-item>
                            <el-breadcrumb-item>产品列表</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
                <el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
                    <el-button type="primary" class="btn-bg-p" @click="handleGoods('add')">添加 <i class="el-icon-plus"></i></el-button>
                    <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <el-form-item prop="name" label="产品名称：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.name" size="small" placeholder="产品名称" clearable></el-input>
                        </el-form-item>
						<el-form-item prop="desk_number" label="所属店铺：">
						    <el-select size="small" v-model="form_search.desk_number" placeholder="请选择">
						        <el-option
						                v-for="item in init_data.desk_list"
						                :key="item.number"
						                :label="item.name"
						                :value="item.number">
						        </el-option>
						    </el-select>
						</el-form-item>
                        <el-form-item prop="category_id" label="平台分类：">
                            <el-cascader
                                    :options="init_data.product_category_list"
                                    :props="optionProps"
                                    clearable
                                    v-model="category_select"
                                    expand-trigger="hover"
                                    @change="searchCategory"
                                    size="small"
                            ></el-cascader>
                        </el-form-item>
						<el-form-item prop="group_id" label="产品分类：">
						    <el-select size="small" v-model="form_search.group_id" placeholder="请选择">
						        <el-option
						                v-for="item in init_data.product_group_list"
						                :key="item.id"
						                :label="item.name"
						                :value="item.id">
						        </el-option>
						    </el-select>
						</el-form-item>
                        <el-form-item prop="status" label="状态：">
                            <el-select size="small" v-model="form_search.status" placeholder="请选择">
                                <el-option
                                        v-for="item in init_data.status_list"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
							<el-table-column prop="name" align="center" label="产品名称" min-width="160">
							    <template slot-scope="scope">
							        <my-textEllipsis v-if="is_refresh" :content="scope.row.name"></my-textEllipsis>
							    </template>
							</el-table-column>
							<el-table-column prop="desk_name" align="center" label="所属店铺" min-width="160">
							    <template slot-scope="scope">
							        <my-textEllipsis :content="scope.row.desk_name"></my-textEllipsis>
							    </template>
							</el-table-column>
                            <el-table-column prop="product_category_name" align="center" label="平台分类" min-width="180">
                                <template slot-scope="scope">
                                    <span>{{scope.row.product_category_name}}->{{scope.row.product_category_name2}}</span>
                                </template>
                            </el-table-column>
							<el-table-column prop="name" align="center" label="产品分类" min-width="120">
							    <template slot-scope="scope">
							        <span>{{scope.row.product_group_name}}</span>
							    </template>
							</el-table-column>
                            <el-table-column prop="image_url" align="center" label="产品图片" min-width="80">
                                <template slot-scope="scope">
                                    <img class="cursor" :src="baseUrl + scope.row.image_url" height="23" @click="dlg_preview.img_url = baseUrl + scope.row.image_url;dlg_preview.visible = true;" title="点击查看" />
                                </template>
                            </el-table-column>
							<el-table-column prop="origin_price" align="center" label="原价" min-width="80">
							</el-table-column>
							<el-table-column prop="sale_price" align="center" label="售价" min-width="80">
							</el-table-column>
							<el-table-column prop="unit" align="center" label="单位" min-width="80">
							</el-table-column>
                            <el-table-column prop="intro" align="center" label="产品简介" min-width="120">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.intro"></my-textEllipsis>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" align="center" label="产品描述" min-width="120">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.remark"></my-textEllipsis>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sort" align="center" label="排序" min-width="80">
                            </el-table-column>
                            <el-table-column prop="status_name" align="center" label="状态" min-width="80" fixed="right">
                                <template slot-scope="scope">
                                    <span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="operating" align="center" label="操作" min-width="120" fixed="right">
                                <template slot-scope="scope">
                                    <el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleGoods('edit',scope.row)">编辑</el-button>
                                    <el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteGoods(scope.row.id)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog class="dialog-export goods-dialog" :title="dlg_goods.title" :visible.sync="dlg_goods.visible" width="1000px" @closed="closeGoods" :close-on-click-modal="false">
            <el-form ref="formGoods" :model="dlg_goods.form" label-width="120px" :rules="dlg_goods.rules" @submit.native.prevent>
                <el-row style="margin-top: 15px;" :gutter="20">
                    <el-col :span="8">
                        <el-form-item prop="name" label="产品名称：" :error="dlg_goods.error.name">
                            <el-input size="small" v-model="dlg_goods.form.name" placeholder='请输入产品名称' clearable></el-input>
                        </el-form-item>
                    </el-col>
					<el-col :span="10">
					    <el-form-item  prop="desk_number" label="所属店铺：">
					        <el-select size="small" v-model="dlg_goods.form.desk_number" placeholder="请选择" @change="selectShop">
					            <el-option
					                    v-for="item in dlg_goods.init_data.desk_list"
					                    :key="item.number"
					                    :label="item.name"
					                    :value="item.number">
					            </el-option>
					        </el-select>
					    </el-form-item>
					</el-col>
                    <el-col :span="8">
                        <el-form-item prop="category_id" label="平台分类：" :error="dlg_goods.error.category_id">
                            <el-cascader
                                    :options="dlg_goods.init_data.product_category_list"
                                    :props="dlg_goods.optionProps"
                                    clearable
                                    v-model="dlg_goods.category_select"
                                    expand-trigger="hover"
                                    @change="selectCategory"
                                    size="small"
                            ></el-cascader>
                        </el-form-item>
                    </el-col>
					<el-col :span="8">
						<el-form-item  prop="group_id" label="产品分类：">
							<el-select size="small" v-model="dlg_goods.form.group_id" placeholder="请选择" >
								<el-option
										v-for="item in dlg_goods.init_data.product_group_list"
										:key="item.id"
										:label="item.name"
										:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="intro" label="产品简介：" :error="dlg_goods.error.intro">
                            <el-input v-model="dlg_goods.form.intro" type="textarea" :rows="3" size="small" placeholder="请输入产品简介"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="remark" label="产品描述：" :error="dlg_goods.error.remark">
                            <el-input v-model="dlg_goods.form.remark" type="textarea" :rows="3" size="small" placeholder="请输入产品描述"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="image_url" label="产品主图：" ref="imageUrl" :error="dlg_goods.error.image_url">
                            <el-upload
                                    :action="dlg_goods.params.action"
                                    :headers="dlg_goods.params.headers"
                                    :data="dlg_goods.params.data"
                                    accept="image/png,image/jpeg,image/jpg"
                                    :class="dlg_goods.hide_upload?'hide-upload head-upload':'head-upload'"
                                    list-type="picture-card"
                                    :file-list="dlg_goods.img_list"
                                    name="file"
                                    :on-preview="(file) => {dlg_preview.img_url = file.url;dlg_preview.visible = true;}"
                                    :on-remove="removeImg"
                                    :before-upload="beforeUpload"
                                    :on-success="uploadSuccessImg">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                            <p class="img-tips">图片尺寸：750px*560px（请上传小于1M的图片）</p>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="origin_price" label="产品原价：" :error="dlg_goods.error.origin_price">
                            <el-input size="small" type='number' v-model="dlg_goods.form.origin_price" placeholder='请输入产品原价' clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="sale_price" label="销售价：" :error="dlg_goods.error.sale_price">
                            <el-input size="small" type='number' v-model="dlg_goods.form.sale_price" placeholder='请输入销售价' clearable></el-input>
                        </el-form-item>
                    </el-col>
					<el-col :span="12">
					    <el-form-item prop="sale_price" label="普通会员价：" :error="dlg_goods.error.sale_price_v1">
					        <el-input size="small" type='number' v-model="dlg_goods.form.sale_price_v1" placeholder='请输入普通会员价' clearable></el-input>
					    </el-form-item>
					</el-col>
					<el-col :span="12">
					    <el-form-item prop="sale_price" label="白金会员价：" :error="dlg_goods.error.sale_price_v2">
					        <el-input size="small" type='number' v-model="dlg_goods.form.sale_price_v2" placeholder='请输入白金会员价' clearable></el-input>
					    </el-form-item>
					</el-col>
					<el-col :span="12">
					    <el-form-item prop="sale_price" label="钻石会员价：" :error="dlg_goods.error.sale_price_v3">
					        <el-input size="small" type='number' v-model="dlg_goods.form.sale_price_v3" placeholder='请输入钻石会员价' clearable></el-input>
					    </el-form-item>
					</el-col>
					<el-col :span="12">
					    <el-form-item prop="sale_price" label="至尊会员价：" :error="dlg_goods.error.sale_price_v4">
					        <el-input size="small" type='number' v-model="dlg_goods.form.sale_price_v4" placeholder='请输入至尊会员价' clearable></el-input>
					    </el-form-item>
					</el-col>
                </el-row>
                <el-row style="margin-top: 15px;" :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="unit" label="单位：" :error="dlg_goods.error.unit">
                            <el-input size="small" v-model="dlg_goods.form.unit" placeholder='请输入单位' clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="sort" label="排序：" :error="dlg_goods.error.sort">
                            <el-input size="small" type='number' v-model="dlg_goods.form.sort" placeholder='请输入排序（输入数字）' clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dlg_goods.visible = false">取 消</el-button>
                <el-button type="primary" @click="submitGoods()" :loading="dlg_goods.btn_loading">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
            <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            var valiImg = (rule, value, callback) =>
            {
                if (!this.dlg_goods.hide_upload) {
                    callback(new Error("请上传产品主图"));
                } else {
                    callback();
                }
            };
            return {
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                //搜索
                category_select:[],
                form_search:{
                    name:"",
                    category_id:0,
                    category_id2:0,
					desk_number:'',
                    status: -1
                },
                optionProps:{
                    value: "id",
                    label: "value",
                    children: "childrens"
                },
                init_data: {
                    product_category_list:[{id: 0, value: "全部", childrens: [{id: 0, value: "全部"}]}],
					product_group_list:[{id:-1, name: '全部'}],
					desk_list: [{id:-1, name: '全部'}],
					status_list: [{id:-1, name: '全部'}],
                },
                baseUrl:this.$client.IMG_URL,
                timestamp:new Date().getTime(),
                multipleSelection: [],
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 30,
                        total: 130
                    }
                },
                dlg_goods:{
                    id:'',
                    visible:false,
                    btn_loading:false,
                    api: '',
                    title:'',
                    hide_upload: false,
                    img_list: [],
                    img_more_list:[],
                    append_image:[],
                    hasUpload:false,
                    form:{
                        name:'',
                        category_id:null,
                        category_id2:null,
						group_id:0,
                        intro:'',
                        remark:'',
                        image_url:'',
                        number:'',
						desk_number:'',
                        staple_food:'',
                        supplementary_food:'',
                        taste:'',
                        weight:'',
                        origin_price:'',
                        sale_price:'',
						sale_price_v1:'',
						sale_price_v2:'',
						sale_price_v3:'',
						sale_price_v4:'',
                        packing_price:'',
                        unit:'份',
                        sort:'',
                        status:1
                    },
                    error:{
                        name:'',
                        category_id:'',
                        category_id2:'',
						group_id:'',
                        intro:'',
                        remark:'',
                        image_url:'',
                        number:'',
						desk_number:'',
                        staple_food:'',
                        supplementary_food:'',
                        taste:'',
                        weight:'',
                        origin_price:'',
                        sale_price:'',
						sale_price_v1:'',
						sale_price_v2:'',
						sale_price_v3:'',
						sale_price_v4:'',
                        packing_price:'',
                        unit:'',
                        sort:'',
                        status:''
                    },
                    reset_form: {},
                    init_data:{
                        product_category_list:[],
						product_group_all_list:[],
						product_group_list: [],
						desk_list: [],
                        status_list: []
                    },
                    category_select: [],
                    optionProps: {
                        value: "id",
                        label: "value",
                        children: "childrens"
                    },
                    rules:{
                        name:{required: true, message: '请输入产品名称', trigger: ['change','blur']},
                        category_id:{required: true, message: '请选择平台分类', trigger: ['change','blur']},
						group_id:{required: true, message: '请选择产品分类', trigger: ['change','blur']},
						desk_number:{required: true, message: '请选择所属店铺', trigger: ['change','blur']},
                        image_url:{required: true, validator: valiImg},
                        // intro:{required: true, message: '请选择产品简介', trigger: ['change','blur']},
                        // number:{required: true, message: '请选择产品编码', trigger: ['change','blur']},
                        origin_price:{required: true, message: '请输入产品原价', trigger: ['change','blur']},
                        sale_price:{required: true, message: '请输入产品销售价', trigger: ['change','blur']},
						sale_price_v1:{required: true, message: '请输入普通会员价', trigger: ['change','blur']},
						sale_price_v2:{required: true, message: '请输入白金会员价', trigger: ['change','blur']},
						sale_price_v3:{required: true, message: '请输入钻石会员价', trigger: ['change','blur']},
                        sale_price_v4:{required: true, message: '请输入至尊会员价', trigger: ['change','blur']},
                        unit:{required: true, message: '请输入单位', trigger: ['change','blur']},
                        sort:{required: true, message: '请输入排序（输入数字）', trigger: ['change','blur']},
                    },
                    params:{
                        action: this.$client.API_URL+'/adminapi/upload/images',
                        data:{path:'goods'},
                        headers:{token:localStorage.getItem('token')}
                    },
                },
                dlg_preview:{
                    visible: false,
                    img_url: ''
                }
            }
        },
        created() {
            document.title = '产品管理';
            this.dlg_goods.reset_form = Object.assign({}, this.dlg_goods.form);
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                var status_default = [{id:-1, name: '全部'}];
				var desk_default = [{id:-1, name: '全部'}];
				var group_default = [{id:0, name: '全部'}];
                var category_default = [{id: 0, value: "全部", childrens: [{id: 0, value: "全部"}]}];
                this.$client.get('/adminapi/productsku/supplierlist', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.dlg_goods.init_data.product_category_list = res.product_category_list;
					_this.dlg_goods.init_data.product_group_all_list = res.product_group_list;
					_this.dlg_goods.init_data.desk_list = res.desk_name_list;
                    _this.dlg_goods.init_data.status_list = res.status_name_list;
                    _this.init_data.product_category_list = category_default.concat(res.product_category_list);
					_this.init_data.product_group_list = group_default.concat(res.product_group_list);
					_this.init_data.desk_list = desk_default.concat(res.desk_name_list);
                    _this.init_data.status_list = status_default.concat(res.status_name_list);
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            handleSizeChange(val) {
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.table_data.page_info.page = val;
                this.getList();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delmultiple(){
                var _this = this;
                var mullist = this.multipleSelection;
                if(mullist.length == 0){
                    _this.$message("请勾选需要删除的产品");
                    return;
                }
                var idList = [];
                for(var i=0;i<mullist.length;i++){
                    idList.push(mullist[i].id);
                }
                var params = {id:idList.join(",")}
                this.$confirm('确定要批量删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/productsku/supplierdelete', params, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            searchCategory(val){
                this.form_search.category_id = val[0];
                this.form_search.category_id2 = val[1];
            },
            selectCategory(val){
                this.dlg_goods.form.category_id = val[0];
                this.dlg_goods.form.category_id2 = val[1];
            },
			selectShop(val){
				// 筛选出对应店铺的分组
				this.dlg_goods.init_data.product_group_list = [];
				this.dlg_goods.form.group_id = '';
				if(this.dlg_goods.init_data.product_group_all_list.length > 0){
					for(let key in this.dlg_goods.init_data.product_group_all_list){
						if(this.dlg_goods.form.desk_number == this.dlg_goods.init_data.product_group_all_list[key]['desk_number']){ // 过滤
							this.dlg_goods.init_data.product_group_list.push(this.dlg_goods.init_data.product_group_all_list[key]);
						}
					}
				}
			},
            handleGoods(type,data){
                this.dlg_goods.visible = true;
                if(type == 'add'){
                    this.dlg_goods.title = '添加产品';
                    this.dlg_goods.api = '/adminapi/productsku/suppliersave';
                }else{
                    this.dlg_goods.id= data.id;
                    this.dlg_goods.title = '编辑产品';
                    if(data){
                        for(var key in this.dlg_goods.form){
                            this.dlg_goods.form[key] = data[key];
                        }
                        this.dlg_goods.category_select = [data.category_id,data.category_id2];
						// 筛选出对应店铺的分组
						this.dlg_goods.init_data.product_group_list = [];
						if(this.dlg_goods.init_data.product_group_all_list.length > 0){
							for(let key in this.dlg_goods.init_data.product_group_all_list){
								if(this.dlg_goods.form.desk_number == this.dlg_goods.init_data.product_group_all_list[key]['desk_number']){ // 过滤
									this.dlg_goods.init_data.product_group_list.push(this.dlg_goods.init_data.product_group_all_list[key]);
								}
							}
						}
                    }
                    if(data.image_url){
                        this.dlg_goods.img_list = [{name: data.name, url: this.baseUrl + data.image_url}];
                        this.dlg_goods.hide_upload = true;
                    }else{
                        this.dlg_goods.img_list = [];
                        this.dlg_goods.hide_upload = false;
                    }
                    this.dlg_goods.api = '/adminapi/productsku/suppliersave?id=' + data.id;
                }
            },
            deleteGoods(id){
                var _this = this;
                this.$confirm('确定要删除？', "", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            iconClass:"icon-delete el-icon-delete",
                            customClass:"my-confirm-box",
                            center: true,
                        })
                        .then(() => {
                    _this.$client.post('/adminapi/productsku/supplierdelete', {id:id}, function(res,message){
                    _this.getList();
                },function(res){

                });
            })
            .catch(() => {});
            },
            uploadSuccessImg(res, file, fileList){
                this.dlg_goods.img_list = fileList;
                this.$refs.formGoods.validateField('image_url');
                this.dlg_goods.form.image_url = res.data.file_url;
                this.dlg_goods.hide_upload = true;
                this.$refs.imageUrl.clearValidate();
            },
            removeImg(file, fileList){
                this.dlg_goods.form.image_url = '';
                this.dlg_goods.img_list = [];
                this.dlg_goods.hide_upload = false;
                this.$refs.imageUrl.validate();
            },
            beforeUpload(file){
                var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
                const extension = testmsg === 'png'
                const extension2 = testmsg === 'jpg'
                const extension3 = testmsg === 'jpeg'
                const isLt2M = file.size / 1024 / 1024 < 1;
                if(!extension && !extension2 && !extension3 && !extension4) {
                    this.$message("图片只能是 png、jpg、jpeg格式!");
                    return false;
                }
                if(!isLt2M) {
                    this.$message("图片大小不能超过1M!请重新选择!");
                    return false;
                }
                return extension || extension2 || extension3 && isLt2M;
            },
            submitGoods(){
                var _this = this;
                _this.$refs['formGoods'].validate((valid) => {
                    if (valid) {
                        this.dlg_goods.btn_loading = true;
                        this.$client.post(this.dlg_goods.api, this.dlg_goods.form, function(res,message){
                            //console.log(res)
                            _this.$message(message);
                            _this.getList();
                            _this.dlg_goods.btn_loading = false;
                            _this.dlg_goods.visible = false;
                        }, function(message){
                            _this.dlg_goods.btn_loading = false;
                            if((typeof message)==='object'){
                                for(var key in message){
                                    _this.dlg_goods.error[key] = message[key];
                                }
                            }
                        });
                    } else {
                        console.log('error submit!!');
                return false;
            }
            });
            },
            closeGoods(){
                this.dlg_goods.img_list = [];
                this.dlg_goods.hide_upload = false;
                this.dlg_goods.category_select = [];
                for(var key in this.dlg_goods.form){
                    this.dlg_goods.form[key] = this.dlg_goods.reset_form[key];
                }
                this.$nextTick(()=>{
                    this.$refs.formGoods.clearValidate();
            })
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            }
        }
    }
</script>
<style>
    .page-goods .el-upload--picture-card{
        line-height: 80px;
    }
    .page-goods .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width: 80px;
        height: 80px;
    }
    .hide-upload .el-upload--picture-card {
        display: none;
    }
</style>
<style scoped>
    .img-tips{
        color: #f31a5c;
        font-size: 12px;
    }
</style>